import {
    AccountManager,
    ClientFeatureUsageInfo,
    GetClientPlanResponse,
    GetClientPlanWithUsageResponse,
    PlanWithFeatures,
} from '../clientContracts/plan/planDTO';
import { requestHandler } from '../utils';

const API_ENDPOINTS = {
    CLIENT_PLAN: '/api/plan/client-plan',
    PLANS: '/api/plan',
    FEATURE_USAGE: '/api/plan/client-plan/feature-usage',
    START_PLAN: '/api/plan/client-plan/start',
    CLIENT_PLAN_WITH_USAGE: '/api/plan/client-plan-with-usage',
    ACCOUNT_MANAGERS: '/api/users/v2/account-managers',
    CURRENT_BILLING_PERIOD: '/api/plan/client-plan/current-billing-period',
} as const;

export const planApi = {
    getClientPlan: () => requestHandler<GetClientPlanResponse>('GET', API_ENDPOINTS.CLIENT_PLAN),
    getAllPlans: () => requestHandler<PlanWithFeatures[]>('GET', API_ENDPOINTS.PLANS),
    getFeatureUsage: () =>
        requestHandler<ClientFeatureUsageInfo[]>('GET', API_ENDPOINTS.FEATURE_USAGE),
    startPlan: (planId: number, billingPeriod: string) =>
        requestHandler('PUT', API_ENDPOINTS.START_PLAN, { planId, billingPeriod }),
    getClientPlanWithUsage: () =>
        requestHandler<GetClientPlanWithUsageResponse>('GET', API_ENDPOINTS.CLIENT_PLAN_WITH_USAGE),
    getAccountManagers: () =>
        requestHandler<AccountManager[]>('GET', API_ENDPOINTS.ACCOUNT_MANAGERS),
    getCurrentBillingPeriod: () => requestHandler('GET', API_ENDPOINTS.CURRENT_BILLING_PERIOD),
};
